// Verde vocabulary expansion — FAMILY theme (net-new cards).
//
// Extends the `family` blocks in ./vocabulary.js without reusing any headword
// already defined there. Seed upserts on `spanish`, so every value is unique.
//   [ spanish, english, emoji, part_of_speech, gender, example_es, example_en ]

export const VOCAB_FAMILY = [
  {
    theme: "family", tier: "A1", rows: [
      ["los padres", "parents", "👪", "noun", "m", "Mis padres viven en Oslo.", "My parents live in Oslo."],
      ["los hijos", "children", "👧", "noun", "m", "Tienen tres hijos.", "They have three children."],
      ["el marido", "husband", "🤵", "noun", "m", "Su marido cocina muy bien.", "Her husband cooks very well."],
      ["la pareja", "partner / couple", "💑", "noun", "f", "Vive con su pareja.", "She lives with her partner."],
      ["el novio", "boyfriend", "❤️", "noun", "m", "Mi novio es de Sevilla.", "My boyfriend is from Seville."],
      ["la novia", "girlfriend", "💕", "noun", "f", "Su novia habla francés.", "His girlfriend speaks French."],
      ["el gemelo", "twin", "👬", "noun", "m", "Su gemelo vive en Madrid.", "His twin lives in Madrid."],
      ["casarse", "to get married", "💒", "verb", "", "Se casan en junio.", "They're getting married in June."],
      ["la boda", "wedding", "💍", "noun", "f", "La boda es en septiembre.", "The wedding is in September."],
      ["el hijo único", "only child", "🧒", "phrase", "", "Soy hijo único.", "I'm an only child."],
    ],
  },
  {
    theme: "family", tier: "A2", rows: [
      ["la sobrina", "niece", "👧", "noun", "f", "Mi sobrina cumple diez años.", "My niece turns ten."],
      ["la nieta", "granddaughter", "👧", "noun", "f", "Su nieta nació en marzo.", "His granddaughter was born in March."],
      ["la prima", "cousin (f)", "👩", "noun", "f", "Mi prima vive en Chile.", "My cousin lives in Chile."],
      ["la suegra", "mother-in-law", "👵", "noun", "f", "Mi suegra es muy amable.", "My mother-in-law is very kind."],
      ["la cuñada", "sister-in-law", "👩", "noun", "f", "Su cuñada es enfermera.", "His sister-in-law is a nurse."],
      ["la nuera", "daughter-in-law", "👰", "noun", "f", "Su nuera trabaja en el banco.", "Her daughter-in-law works at the bank."],
      ["el padrino", "godfather", "🎩", "noun", "m", "Mi padrino vive cerca.", "My godfather lives nearby."],
      ["divorciado", "divorced", "💔", "adjective", "", "Mis padres están divorciados.", "My parents are divorced."],
      ["el padrastro", "stepfather", "👨", "noun", "m", "Su padrastro es muy paciente.", "Her stepfather is very patient."],
      ["la madrastra", "stepmother", "👩", "noun", "f", "Mi madrastra cocina genial.", "My stepmother cooks brilliantly."],
    ],
  },
  {
    theme: "family", tier: "B1", rows: [
      ["el hogar", "home / household", "🏡", "noun", "m", "Echo de menos mi hogar.", "I miss my home."],
      ["el lazo", "tie / bond", "🔗", "noun", "m", "Hay un lazo fuerte entre ellos.", "There's a strong tie between them."],
      ["el apoyo", "support", "🤝", "noun", "m", "Cuento con el apoyo de mi familia.", "I count on my family's support."],
      ["la separación", "separation", "💔", "noun", "f", "La separación fue difícil.", "The separation was hard."],
      ["acoger", "to take in", "🫂", "verb", "", "Acogieron a un niño refugiado.", "They took in a refugee child."],
      ["el seno familiar", "the family fold", "👪", "phrase", "", "Creció en el seno de una familia humilde.", "He grew up in a humble family."],
      ["los allegados", "close relations", "👥", "noun", "m", "Solo vinieron los allegados.", "Only close relations came."],
      ["consanguíneo", "blood-related", "🧬", "adjective", "", "No son parientes consanguíneos.", "They are not blood relatives."],
      ["la descendencia", "offspring", "🌳", "noun", "f", "No tuvieron descendencia.", "They had no offspring."],
      ["velar por", "to watch over", "🕯️", "phrase", "", "Los padres velan por sus hijos.", "Parents watch over their children."],
    ],
  },
];
